<template>
  <video
    v-if="((payload.mp4 && payload.mp4.file) || (payload.webm && payload.webm.file)) && !isMobile"
    :class="((payload.mp4 && payload.mp4.file) || (payload.webm && payload.webm.file)) && !isMobile ? 'show' : 'hide'"
    class="desktop-video"
  >
    <source
      :src="resourceUrl + payload.mp4.file.path"
      type="video/mp4"
      v-if="payload.mp4 && payload.mp4.file"
    />
    <source
      :src="resourceUrl + payload.webm.file.path"
      type="video/webm"
      v-if="payload.webm && payload.webm.file"
    />
  </video>
  <video
    class="mobile-video"
    v-else-if="((payload.mp4Mobile && payload.mp4Mobile.file) || (payload.webmMobile && payload.webmMobile.file)) && isMobile"
    :class="((payload.mp4Mobile && payload.mp4Mobile.file) || (payload.webmMobile && payload.webmMobile.file)) && isMobile ? 'show' : 'hide'"
  >
    <source
      :src="resourceUrl + payload.mp4Mobile.file.path"
      type="video/mp4"
      v-if="payload.mp4Mobile && payload.mp4Mobile.file"
    />
    <source
      :src="resourceUrl + payload.webmMobile.file.path"
      type="video/webm"
      v-if="payload.webmMobile && payload.webmMobile.file"
    />
  </video>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "responsive-video",
  props: {
    payload: {
      required: true
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "getIsMobile"
    })
  }
};
</script>
<style lang="scss" scoped>
</style>